const BAR_COUNT = 28;

export function buildWaveformHeights(seed: string, count = BAR_COUNT): number[] {
  return Array.from({ length: count }, (_, i) => {
    const len = Math.max(seed.length, 1);
    const s = (seed.charCodeAt(i % len) || i) % 10;
    return 0.15 + 0.8 * Math.abs(Math.sin(i * 0.45 + s));
  });
}

export function formatAudioDuration(totalMs: number): string {
  const totalSec = Math.max(0, Math.floor(totalMs / 1000));
  const min = Math.floor(totalSec / 60);
  const sec = totalSec % 60;
  return `${min}:${sec.toString().padStart(2, '0')}`;
}

export { BAR_COUNT };
